export const sanitizePositiveNumberInput = (newValue: string) => {
  if (!newValue) return "";

  const numberValue = Number(newValue);
  return isNaN(numberValue) || numberValue < 0 ? "0" : String(numberValue);
};
